import React from 'react';
import { useCountdown } from '../utils/useCountdown';
type CountdownProps = {
  variant?: 'block' | 'inline';
};
export function CountdownTimer({
  variant = 'block'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hrs'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className={`flex items-stretch justify-center gap-2 ${variant === 'inline' ? '' : 'mt-2'}`} role="timer" aria-label="Offer countdown" data-id="element-49" data-mp="3c25rd9zgs002">
      {units.map(unit => <div key={unit.label} className="min-w-[62px] rounded-lg bg-charcoal px-3 py-1.5 text-center sm:min-w-[80px]" data-id="element-50" data-mp="323yb6td01lz4">
          <span className="block font-display text-2xl tabular-nums leading-none text-white sm:text-3xl" data-id="element-51" data-mp="373b9ca9bmfh0">
            {unit.value}
          </span>
          <span className="block font-head text-[9px] font-semibold uppercase tracking-widest text-white/60 sm:text-[11px]" data-id="element-52" data-mp="15b6b6h18alxu">
            {unit.label}
          </span>
        </div>)}
    </div>;
}
export function OfferBar() {
  return <section aria-label="Limited-time offer" className="w-full bg-ivory px-4 py-6 sm:px-6" data-id="element-53" data-mp="t1ahbbxaagbo">
      <div className="mx-auto max-w-3xl rounded-xl border border-urgent/40 bg-white p-4 text-center" data-id="element-54" data-mp="17pohff3bfqoj">
        <span className="inline-block rounded-full bg-urgent px-3 py-1 font-head text-[10px] font-semibold uppercase tracking-wider text-white sm:text-xs" data-id="element-55" data-mp="12t7rqgggx49c">
          Limited-Time Offer
        </span>
        <p className="mt-1.5 font-head text-sm font-semibold uppercase tracking-wide text-charcoal sm:text-base" data-id="element-56" data-mp="a4iz75tha797">
          Launch price ends in:
        </p>
        <CountdownTimer data-id="element-57" data-mp="k1nc0f1foqdc" />
        <p className="mt-2 text-xs leading-snug text-softgray sm:text-[13px]" data-id="element-58" data-mp="k0c9sjnmzqoc">
          After that, the price increases and the strategic bonuses may no longer be included.
        </p>

        <div className="mx-auto mt-3 max-w-md" data-id="element-59" data-mp="1vhc1bd25u1hb">
          <div className="flex items-center justify-between font-head text-[10px] font-semibold uppercase tracking-wider text-charcoal sm:text-xs" data-id="element-60" data-mp="1vin4pbrp177w">
            <span data-id="element-61" data-mp="x3yef6mrdsr8">Limited Availability</span>
            <span className="text-urgent" data-id="element-62" data-mp="x2wsg747fluq">72% Claimed</span>
          </div>
          <div className="mt-1 h-2.5 w-full overflow-hidden rounded-full bg-charcoal/10" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Availability claimed" data-id="element-63" data-mp="1255nd90n0xzh">
            <div className="h-full rounded-full bg-urgent" style={{
            width: '72%'
          }} data-id="element-64" data-mp="edgr5hkp3pd9" />
          </div>
        </div>
      </div>
    </section>;
}